// Field groups for AbstractDocument notToShow lists. The shared filter
// schema renders EVERY key not excluded, so every editor must hide the
// groups that don't apply to its type — a new schema field gets added to a
// group here ONCE instead of to a dozen per-editor lists. (The Slide dialog
// leaking all 23 homepage/LocalBusiness fields is exactly the bug this
// prevents.)
const SLIDE_FIELDS = [
  'heading',
  'headingAr',
  'subheading',
  'subheadingAr',
  'ctaLabel',
  'ctaLabelAr',
  'ctaUrl',
  'order',
]

const HOMEPAGE_FIELDS = [
  'heroTagline',
  'heroTaglineAr',
  'aboutUsBody',
  'aboutUsBodyAr',
  'aboutUsImage',
  'aboutUsImageAlt',
  'aboutUsImageAltAr',
  'designWorkIntro',
  'designWorkIntroAr',
  'fitoutIntro',
  'fitoutIntroAr',
  'servicesIntro',
  'servicesIntroAr',
  'blogIntro',
  'blogIntroAr',
]

const LOCAL_BUSINESS_FIELDS = [
  'localBusinessAddress',
  'localBusinessAddressAr',
  'localBusinessPhone',
  'localBusinessEmail',
  'localBusinessLogo',
  'localBusinessGeoLat',
  'localBusinessGeoLng',
  'localBusinessHours',
]

const PAGE_META_FIELDS = [
  'windowTitle',
  'windowTitleAr',
  'metaDescription',
  'metaDescriptionAr',
  'h1',
  'h1Ar',
  'robotsMeta',
]

module.exports = {
  SLIDE_FIELDS,
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  PAGE_META_FIELDS,
}
